import {
  SlRadio
} from "./chunk.ZSG32LO3.js";

// src/components/radio/radio.ts
var radio_default = SlRadio;
SlRadio.define("sl-radio");

export {
  radio_default
};
